import lodash from 'lodash';
import styles from './DocumentAttributes.scss';
import DescriptorValue from 'common/components/DescriptorValue/DescriptorValue';

export const DocumentAttributes = props => {
    const {document} = props;

    if (lodash.isEmpty(document.descriptors)) {
        return null;
    }

    const renderedAttributes = lodash.map(document.descriptors, ga => {
        const {id, displayName} = ga;

        const renderedValues = lodash.map(ga.values, (value, index) => {
            return <DescriptorValue value={value} dataType={ga.dataType} key={index} />;
        });

        return (
            <div key={id} className={styles.documentAttribute} data-cy={'DocumentAttributes' + id}>
                <span className={styles.attributeName} data-cy={'displayName-DocumentAttributes' + id}>{displayName}</span>
                <div className={styles.attributeValues} data-cy={'renderedValues-DocumentAttributes' + id}>
                    {renderedValues}
                </div>
            </div>
        );
    });

    return (
        <section className={styles.documentAttributesArea} data-cy="renderedValues-section">
            <header className={styles.header}>
                Document Attributes
            </header>
            <div className={styles.documentAttributes} data-cy="renderedValues-renderedAttributes">
                {renderedAttributes}
            </div>
        </section>
    );
};

export default DocumentAttributes;
